import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJblComponent } from './simple-icons-jbl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJblComponent ],
    exports:      [ SimpleIconsJblComponent ],
    bootstrap:    []
})
export class SimpleIconsJblModule {}
